import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { PageHeader } from "@/widgets/page-header"
import { fetchTradingFoundations, selectSocialMarketFoundationsFirstLoad, selectSocialMarketFoundationsSearchQuery } from "../model"
import { useEffect, useRef } from "react"
import { SocialMarketFoundationsFilters } from "./social-market-founations-filters"
import { FoundationsGrid } from "./foundations-grid"

export const SocialMarketFoundationsPage = () => {
    const isFirstRender = useRef(true)
    const isFirstLoad = useAppSelector(selectSocialMarketFoundationsFirstLoad)
    const dispatch = useAppDispatch()
    const search = useAppSelector(selectSocialMarketFoundationsSearchQuery)

    useEffect(() => {
        if (!isFirstRender.current) {
            dispatch(fetchTradingFoundations())
        }
    }, [search])

    useEffect(() => {
        if (isFirstLoad) {
            dispatch(fetchTradingFoundations())
        }
        isFirstRender.current = false
    }, [])

    return (
        <div className="_page_container flex-1">
            <PageHeader title="Маркет социальных программ" />
            <div className='flexbox h-full '>
                <PageSubtitle title="Фонды" />
                <SocialMarketFoundationsFilters />
                <FoundationsGrid />
            </div>
        </div>
    )
}